import React from 'react';
import {UiText} from '~/components/elements';

export const TitlePopup = ({children}: {children: string}) => {
  return (
    <UiText style={{fontSize: '16px', fontWeight: 700, lineHeight: '24px'}} my={4}>
      {children}
    </UiText>
  );
};
